import styled from "styled-components";
import GenericBody from "../Componentes/GenericBody";
import NavBar from "../Componentes/NavBar";
import Overlay from "../Componentes/Overlay";
import SmallLoading from "../Componentes/Utils/SmallLoading";
import FormComp from "../Componentes/FormComp";
import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";
import Tabela from "../Componentes/Tabela";
import { formatarData } from "../Funcoes/FormatarData";
import SideMenu from "../Componentes/SideMenu";
import SideMenuBtn from "../Componentes/SideMenuBtn";
import { toast, ToastContainer } from "react-toastify";
import GenericHeader from "../Componentes/GenericHeader";
import Filters from "../Componentes/Utils/Filters";
import FilterContainer from "../Componentes/Utils/FilterContainer";

import { TbCloudDownload, TbCloudUpload } from "react-icons/tb";
import { RiFileExcel2Line } from "react-icons/ri";
import { AiOutlineClose } from "react-icons/ai";
import { CiSearch } from "react-icons/ci";
import FileUploader from "../Componentes/Utils/FileUploader";


const ContainerNewDds = styled.div`
    width: 550px;
    max-width: 95%;
    max-height: 80%;
    background-color: transparent;
    border-radius: 12px;
    margin: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
`
const ContainerHeader = styled.div`
    width: 100%;
    height: 45px;
    background-color: #263B4B;
    flex-shrink: 0;
    display: flex;
`
const ContainerBody = styled.div`
    width: 100%;
    flex: 1;
    background-color: white;
    overflow: auto;
    padding: 10px 20px;
    box-sizing: border-box;
`
const FormularioDds = styled.form`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`
const InputMatContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    color: black;
    p{
        margin: 15px auto 10px auto;
        font-weight: bold;
        color: black;
    }
`
const ContainerMat = styled.div`
    width: 100%;
    height: 40px;
    border: 1px solid #00000049;
    border-radius: 12px;
    display: flex;
    box-sizing: border-box;
    padding: 0 10px;
`
const InputMat = styled.input`
    flex: 1;
    height: 100%;
    border: none;
    outline: none;
    box-sizing: border-box;
`
const IconMat = styled.div`
    height: 100%;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        cursor: pointer;
    }
`
const ModalColabsContainer = styled.div`
    width: 550px;
    max-width: 95%;
    max-height: 80%;
    margin: auto;
    border-radius: 12px;
    overflow: hidden;
`
const ModalColabsHeader = styled.div`
    width: 100%;
    height: 45px;
    background-color: #263B4B;
    flex-shrink: 0;
    display: flex;
`
const ModalColabsBody = styled.div`
    width: 100%;
    max-height: calc( 100% - 45px );
    background-color: white;
    overflow: auto;
    padding: 10px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    h3{
        color: black;
        font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
        margin: 10px auto;
    }
`
const TableWrapper = styled.div`
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #CFD1D0;
    box-sizing: border-box;
    margin-bottom: 15px;
`
const TabelaSubordinados = styled.table`
    width: 100%;
    color: black;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    border-collapse: collapse;
    border: none;
    box-sizing: border-box;
`
const HeaderTable = styled.tr`
    height: 35px;
    background-color: #F6F8FA;
    border-bottom: 1px solid #CFD1D0;
`
const ColunaHead = styled.th`
    padding: 0 0 0 8px;
    box-sizing: border-box;
    text-align: left;
`
const LineTable = styled.tr`
    height: 30px;
    background-color: #FFFFFD;
    border-bottom: 1px solid #CFD1D0;
    &:last-child{
        border: none;
    }
`
const ColunaBody = styled.td`
    padding-left: 10px;
    text-align: left;
    box-sizing: border-box;
`
const CloseModal = styled(AiOutlineClose)`
    width: 30px;
    height: 30px;
    color: red;
    margin: auto 15px auto auto;
    cursor: pointer;
    transition: .3s;
    &:hover{
        scale: 1.1;
    }
`

const ListaDDS = () => {

    const [modalColabs, setModalColabs] = useState(false)
    const [subordinados, setSubordinados] = useState({})

    const [modalForm, setModalForm] = useState(false)

    const temasSeguranca = [
        "ALIMENTAÇÃO SAUDÁVEL NO AMBIENTE DE TRABALHO",
        "ANÁLISE PRELIMINAR DE RISCO — APR NO DIA A DIA",
        "ATENDIMENTO EM CASO DE CHOQUE ELÉTRICO",
        "ATENDIMENTO EM CASO DE QUEIMADURAS",
        "ATOS INSEGUROS — RECONHECER E ELIMINAR",
        "CUIDADOS COM A AUDIÇÃO — PROTEÇÃO AUDITIVA",
        "CUIDADOS COM A COLUNA E LEVANTAMENTO DE PESO",
        "CUIDADOS COM A VISÃO — PROTEÇÃO OCULAR",
        "CUIDAR DE SI E DOS COLEGAS — SEGURANÇA É RESPONSABILIDADE COMPARTILHADA",
        "CULTURA DE SEGURANÇA — SEGURANÇA É DEVER DE TODOS",
        "COMBATE AO ALCOOLISMO E USO DE DROGAS NO TRABALHO",
        "COMUNICAÇÃO EFETIVA EM SEGURANÇA",
        "CONDUTA EM CASO DE ACIDENTE DE TRABALHO",
        "CONTROLE DE DERRAMAMENTOS E EMERGÊNCIAS AMBIENTAIS",
        "DESCARTE CORRETO DE RESÍDUOS",
        "DOENÇAS OCUPACIONAIS E COMO PREVENIR",
        "ERGONOMIA — PREVENÇÃO DE DORES E LESÕES",
        "ESPAÇOS CONFINADOS — RISCOS E PROCEDIMENTOS",
        "HIGIENE PESSOAL NO AMBIENTE DE TRABALHO",
        "IMPACTOS AMBIENTAIS DAS ATIVIDADES DA EMPRESA",
        "IMPORTÂNCIA DA BRIGADA DE INCÊNDIO",
        "IMPORTÂNCIA DA HIDRATAÇÃO",
        "INSPEÇÃO E CONSERVAÇÃO DE EPIs",
        "PRESERVAÇÃO DA ÁGUA E ENERGIA",
        "PREVENÇÃO À FADIGA E ESTRESSE",
        "PREVENÇÃO CONTRA INCÊNDIOS — USO DE EXTINTORES",
        "PREVENÇÃO DE ACIDENTES COM LÍQUIDOS INFLAMÁVEIS",
        "PROCEDIMENTOS EM CASOS DE QUEDAS",
        "PROTEÇÃO DE MÁQUINAS E EQUIPAMENTOS",
        "QUEDAS NO MESMO NÍVEL — COMO EVITAR",
        "RADIAÇÕES IONIZANTES E NÃO IONIZANTES",
        "REUTILIZAÇÃO E RECICLAGEM NO CANTEIRO DE OBRAS",
        "RISCOS DE CHOQUE ELÉTRICO",
        "RISCOS DE PRODUTOS QUÍMICOS (FDS FICHA DE INFORMAÇÕES DE SEGURANÇA)",
        "RISCOS DE QUEDAS EM ALTURA",
        "RISCOS EM TRABALHOS A QUENTE (SOLDA, ESMERILHAMENTO, CORTE)",
        "RUÍDO OCUPACIONAL — DANOS E PREVENÇÃO",
        "SAÚDE MENTAL E EQUILÍBRIO EMOCIONAL",
        "SEGURANÇA EM TRABALHOS COM SOLDA E CORTE",
        "SEGURANÇA NO MANUSEIO DE FERRAMENTAS MANUAIS",
        "SEGURANÇA NO TRANSPORTE DE MATERIAIS",
        "SEGURANÇA NO USO DE LÍQUIDOS PENETRANTES (LP)",
        "SIMULADOS DE EMERGÊNCIA — IMPORTÂNCIA E PARTICIPAÇÃO",
        "SUSTENTABILIDADE NA CONSTRUÇÃO CIVIL",
        "TRABALHOS COM ELETRICIDADE — RISCOS E CUIDADOS",
        "USO CORRETO DOS EPIs",
        "VIBRAÇÃO — EFEITOS NA SAÚDE"
    ];

    const [formValues, setFormValues] = useState({
        encarregado: '',
        nome: '',
        lider: '',
        equipe: '',
        periodo: '',
        centro_custo: '',
        contrato: '',
        inicio_semana: '',
        tema_1: '',
        tema_2: '',
        tema_3: '',
        tema_4: '',
        tema_5: '',
        tema_6: '',
        tema_7: '',
        observacoes: ''
    })

    const handleChange = (field, value) => {
        if (field === 'inicio_semana' && value !== '') {
            const dia_semana = new Date(value).getDay();

            if (value === "" || dia_semana !== 0) {
                alert('A data selecionada não é uma segunda-feira!');
                return;
            }
        }

        setFormValues(prev => ({ ...prev, [field]: value }));
    };

    const [savingDados, setSavingDados] = useState(false);

    const handleSubmit = async (e) => {

        e.preventDefault();

        setSavingDados(true);

        try {

            await toast.promise(
                axios.post(
                    'https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/SaveDDS/',
                    formValues,
                    {
                        withCredentials: true
                    }
                ),
                {
                    pending: "SALVANDO INFORMAÇÕES",
                    success: "DADOS SALVOS COM SUCESSO",
                    error: "ERRO AO SALVAR INFORMAÇÕES"
                }
            )

            await fetchData();
            fecharDDSForm();

        } catch (error) {

            console.log(error)

        } finally {

            setSavingDados(false)

        }

    }

    const getColabsInfo = async (matricula) => {

        try {

            const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/GetColabInfo/', {

                matricula: matricula

            })

            console.log(data)

            setFormValues(prev => ({
                ...prev,
                centro_custo: data[0].CENTRO_CUSTO ? data[0].CENTRO_CUSTO : '-',
                contrato: data[0].CONTRATO ? data[0].CONTRATO : '-',
                nome: data[0].NOME ? data[0].NOME : '-',
                equipe: data[0].DISCIPLINA ? data[0].DISCIPLINA : '-',
                lider: data[0].LIDER ? data[0].LIDER : null
            }
            ));

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {
        const fetchColab = async () => {
            if (formValues.encarregado.length === 6) {

                await getColabsInfo(formValues.encarregado);

            } else {

                setFormValues(prev => ({
                    ...prev,
                    centro_custo: '',
                    contrato: '',
                    nome: '',
                    equipe: '',
                    lider: ''
                }
                ));

            }
        };

        fetchColab();
    }, [formValues.encarregado]);

    const [loadingSubordinados, setLoadingSubordinados] = useState(false);

    const openEncInfo = async () => {

        if (formValues.encarregado.length === 6) {

            setModalColabs(true)
            setLoadingSubordinados(true);

            try {

                const { data } = await axios.post('https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/GetEncInfo/', {
                    matricula: formValues.encarregado
                },
                    {
                        withCredentials: true
                    })

                setSubordinados(data)
                console.log(data)

            } catch (e) {

                console.log(e)

            } finally {

                setLoadingSubordinados(false)

            }

        } else {

            alert("Matricula incompleta!")

        }

    }

    const closeEncInfo = () => {

        setModalColabs(false)
        setLoadingSubordinados(false);

    }

    const [listaDDS, setListaDDS] = useState([])
    const [listaDDSFilter, setListaDDSFilter] = useState([])

    const fetchData = async () => {

        try {

            const { data } = await axios.get('https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/GetDDS/', {
                withCredentials: true
            })

            console.log(data)
            setListaDDS(data)
            setListaDDSFilter(data)

        } catch (e) {

            console.log(e)

        }

    }

    useEffect(() => {

        fetchData();

    }, [])

    const [sideOverlay, setSideOverlay] = useState(false)

    const openSidebar = () => {

        setSideOverlay(true)

    }

    const closeSidebar = () => {

        setSideOverlay(false)

    }

    const gerarNovoDDS = () => {

        setSideOverlay(false)
        setModalForm(true)

        setFormValues({
            encarregado: '',
            nome: '',
            lider: '',
            equipe: '',
            periodo: '',
            centro_custo: '',
            contrato: '',
            area: '',
            inicio_semana: '',
            tema_1: '',
            tema_2: '',
            tema_3: '',
            tema_4: '',
            tema_5: '',
            tema_6: '',
            tema_7: '',
            observacoes: ''
        });

    }

    const fecharDDSForm = () => {

        setModalForm(false);
        setFormValues({
            encarregado: '',
            nome: '',
            lider: '',
            equipe: '',
            periodo: '',
            centro_custo: '',
            contrato: '',
            area: '',
            inicio_semana: '',
            tema_1: '',
            tema_2: '',
            tema_3: '',
            tema_4: '',
            tema_5: '',
            tema_6: '',
            tema_7: '',
            observacoes: ''
        });

    }

    const downloadExcel = async (id, resp_name) => {

        try {

            const { data } = await toast.promise(
                axios.post(
                    "https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/GenerateNewFile/",
                    {
                        id: id
                    },
                    {
                        withCredentials: true,
                        responseType: 'blob'
                    }
                ), {
                pending: "BAIXANDO ARQUIVO",
                success: "ARQUIVO BAIXADO COM SUCESSO",
                error: "FALHA AO BAIXAR ARQUIVO"
            }
            )

            const url = window.URL.createObjectURL(new Blob([data]))
            const link = document.createElement('a')
            link.href = url;
            link.setAttribute('download', `DDS - ${resp_name}.xlsx`);
            document.body.appendChild(link)
            link.click();
            document.body.removeChild(link);

        } catch (e) {

            console.log(e)

        }

    }

    const centro_custos = useMemo(() => [...new Set(listaDDS.map((obj) => obj.centro_custo))].sort(), [listaDDS])
    const contratos = useMemo(() => [...new Set(listaDDS.map((obj) => obj.contrato))].sort(), [listaDDS])

    const [matriculaFilter, setMatriculaFilter] = useState('');
    const [nomeFilter, setNomeFilter] = useState('');
    const [centroCustoFilter, setCentroCustoFilter] = useState([]);
    const [contratoFilter, setContratoFilter] = useState([]);
    const [periodoFilter, setPeriodoFilter] = useState('');
    const [anexoFilter, setAnexoFilter] = useState('');
    const [dataInicioFilter, setDataInicioFilter] = useState('');
    const [dataFimFilter, setDataFimFilter] = useState('');

    const handleFilter = useCallback(() => {
        setListaDDSFilter(
            listaDDS.filter(item => {

                const matriculaOk = !matriculaFilter || item.encarregado.includes(matriculaFilter);
                const nomeOk = !nomeFilter || item.nome.toLowerCase().includes(nomeFilter.toLowerCase());

                const centroCustoOk = !centroCustoFilter.length || centroCustoFilter.some(f => item.centro_custo === f.value);
                const contratoOk = !contratoFilter.length || contratoFilter.some(f => item.contrato === f.value);

                const periodoOk = !periodoFilter.length || periodoFilter.some(obj => (item.periodo || '').includes(obj.value))

                const anexoOk =
                    !anexoFilter.length ||
                    (anexoFilter.some(obj => obj.value === 'OK') && item.anexo !== null) ||
                    (anexoFilter.some(obj => obj.value === 'PENDENTES') && item.anexo === null);

                const dataInicioOk = !dataInicioFilter || new Date(item.semana) >= new Date(dataInicioFilter);
                const dataFimOk = !dataFimFilter || new Date(item.semana) <= new Date(dataFimFilter);

                return matriculaOk && nomeOk && centroCustoOk && contratoOk && periodoOk && anexoOk && dataInicioOk && dataFimOk;
            })
        );
    }, [listaDDS, matriculaFilter, nomeFilter, centroCustoFilter, contratoFilter, periodoFilter, anexoFilter, dataInicioFilter, dataFimFilter]);

    useEffect(() => {

        handleFilter();

    }, [handleFilter])

    const [modalAnexos, setModalAnexos] = useState(false)
    const [idAnexo, setIdAnexo] = useState('')

    const openAnexo = (id) => {

        setModalAnexos(true);
        setIdAnexo(id);

    }

    const closeAnexo = () => {

        setModalAnexos(false);
        setIdAnexo('')

    }

    return (
        <>
            <NavBar title="CONTROLE DE DDS" setSideBar={() => openSidebar()} />
            <GenericBody>
                <GenericHeader>
                    <Filters columns={4}>
                        <FilterContainer
                            type="text"
                            placeholder="MATRICULA..."
                            valor={matriculaFilter}
                            changeFunc={(valor) => setMatriculaFilter(valor)}
                        />
                        <FilterContainer
                            type="text"
                            placeholder="NOME..."
                            valor={nomeFilter}
                            changeFunc={(valor) => setNomeFilter(valor)}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CENTRO CUSTO..."
                            options={centro_custos}
                            optType="obj"
                            valor={centroCustoFilter}
                            changeFunc={setCentroCustoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="CONTRATO..."
                            options={contratos}
                            optType="obj"
                            valor={contratoFilter}
                            changeFunc={setContratoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="PERIODO..."
                            options={[{ value: "MANHA", label: "MANHÃ" }, { value: "TARDE", label: "TARDE" }]}
                            valor={periodoFilter}
                            changeFunc={setPeriodoFilter}
                        />
                        <FilterContainer
                            type="select"
                            placeholder="ANEXO..."
                            options={[
                                "OK",
                                "PENDENTES"
                            ]}
                            optType="obj"
                            valor={anexoFilter}
                            changeFunc={setAnexoFilter}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataInicioFilter}
                            changeFunc={(valor) => setDataInicioFilter(valor)}
                        />
                        <FilterContainer
                            type="date"
                            valor={dataFimFilter}
                            changeFunc={(valor) => setDataFimFilter(valor)}
                        />
                    </Filters>

                </GenericHeader>
                <Tabela>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>MATRICULA</th>
                            <th>ENCARREGADO</th>
                            <th>CENTRO CUSTO</th>
                            <th>CONTRATO</th>
                            <th>PERÍODO</th>
                            <th>INÍCIO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listaDDSFilter.map(obj => (
                                <tr key={obj.id} >
                                    <td>{obj.id}</td>
                                    <td>{obj.encarregado}</td>
                                    <td>{obj.nome}</td>
                                    <td>{obj.centro_custo}</td>
                                    <td>{obj.contrato}</td>
                                    <td>{obj.periodo}</td>
                                    <td>{obj.semana ? formatarData(obj.semana) : '-'}</td>
                                    <td><RiFileExcel2Line size={20} onClick={() => downloadExcel(obj.identifier, obj.nome)} /></td>
                                    <td>
                                        {
                                            obj.anexo ? (
                                                <a href={obj.anexo} download target="_blank" rel="noopener noreferrer">
                                                    <TbCloudDownload size={21} color="green" style={{ cursor: 'pointer' }} />
                                                </a>
                                            ) : (
                                                <TbCloudUpload size={21} color="blue" onClick={() => openAnexo(obj.identifier)} />
                                            )
                                        }
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Tabela>
            </GenericBody>
            <Overlay state={modalForm}>
                <ContainerNewDds>
                    <ContainerHeader>
                        <CloseModal onClick={fecharDDSForm} />
                    </ContainerHeader>
                    <ContainerBody>
                        {
                            savingDados ? (
                                <SmallLoading />
                            ) : (
                                <FormularioDds onSubmit={handleSubmit} >
                                    <InputMatContainer>
                                        <p>ENCARREGADO ( MATRICULA )</p>
                                        <ContainerMat>
                                            <InputMat
                                                type="text"
                                                value={formValues.encarregado}
                                                onChange={(e) => handleChange('encarregado', e.target.value)}
                                                maxLength={6}
                                                required
                                            ></InputMat>
                                            <IconMat>
                                                <CiSearch
                                                    size={30}
                                                    onClick={() => openEncInfo()}
                                                />
                                            </IconMat>
                                        </ContainerMat>
                                    </InputMatContainer>
                                    <FormComp
                                        type="text"
                                        title="NOME | DISCIPLINA"
                                        valor={formValues.nome + " | " + formValues.equipe}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="text"
                                        title="CENTRO DE CUSTO"
                                        valor={formValues.centro_custo}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="text"
                                        title="CONTRATO"
                                        valor={formValues.contrato}
                                        disabled
                                        readOnly
                                    />
                                    <FormComp
                                        type="select"
                                        title="PERIODO"
                                        options={
                                            ["MANHA", "TARDE"]
                                        }
                                        valor={formValues.periodo}
                                        changeFunc={(e) => handleChange('periodo', e.target.value)}
                                        required
                                    />
                                    <FormComp
                                        type="date"
                                        title="SEMANA"
                                        valor={formValues.inicio_semana}
                                        changeFunc={(e) => handleChange('inicio_semana', e.target.value)}
                                        required
                                    />
                                    {
                                        formValues.periodo === "MANHA" && (
                                            <>
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SEGUNDA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_1}
                                                    changeFunc={(e) => handleChange('tema_1', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA TERCA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_2}
                                                    changeFunc={(e) => handleChange('tema_2', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA QUARTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_3}
                                                    changeFunc={(e) => handleChange('tema_3', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA QUINTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_4}
                                                    changeFunc={(e) => handleChange('tema_4', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SEXTA-FEIRA"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_5}
                                                    changeFunc={(e) => handleChange('tema_5', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA SABADO"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_6}
                                                    changeFunc={(e) => handleChange('tema_6', e.target.value)}
                                                />
                                                <FormComp
                                                    type="select"
                                                    title="TEMA DOMINGO"
                                                    options={temasSeguranca}
                                                    valor={formValues.tema_7}
                                                    changeFunc={(e) => handleChange('tema_7', e.target.value)}
                                                />
                                            </>
                                        )
                                    }
                                    <FormComp
                                        type="textarea"
                                        title="OBSERVACOES"
                                        valor={formValues.observacoes}
                                        changeFunc={(e) => handleChange('observacoes', e.target.value)}
                                    />
                                    <FormComp
                                        type="submit"
                                        valor="SALVAR"
                                    />
                                </FormularioDds>
                            )
                        }
                        <Overlay state={modalColabs} >
                            <ModalColabsContainer>
                                <ModalColabsHeader>
                                    <CloseModal onClick={closeEncInfo} />
                                </ModalColabsHeader>
                                <ModalColabsBody>
                                    {
                                        loadingSubordinados ?
                                            <SmallLoading /> :
                                            <>
                                                <h3>{subordinados?.ENCARREGADO}</h3>
                                                <TableWrapper>
                                                    <TabelaSubordinados>
                                                        <thead>
                                                            <HeaderTable>
                                                                <ColunaHead>COLABORADOR</ColunaHead>
                                                                <ColunaHead>MATRICULA</ColunaHead>
                                                            </HeaderTable>
                                                        </thead>
                                                        <tbody>
                                                            <LineTable>
                                                                <ColunaBody>{subordinados?.LIDER?.[0]?.NOME}</ColunaBody>
                                                                <ColunaBody>{subordinados?.LIDER?.[0]?.MATRICULA}</ColunaBody>
                                                            </LineTable>
                                                            {
                                                                subordinados?.SUBORDINADOS?.length === 0 ? (
                                                                    <LineTable>
                                                                        <ColunaBody colSpan={2}>COLABORADOR NÃO POSSUI NENHUM SUBORDINADO</ColunaBody>
                                                                    </LineTable>
                                                                ) : (
                                                                    subordinados?.SUBORDINADOS?.map((obj, index) => (
                                                                        <LineTable key={index}>
                                                                            <ColunaBody>{obj.NOME}</ColunaBody>
                                                                            <ColunaBody>{obj.MATRICULA}</ColunaBody>
                                                                        </LineTable>
                                                                    ))
                                                                )
                                                            }
                                                        </tbody>
                                                    </TabelaSubordinados>
                                                </TableWrapper>
                                            </>
                                    }
                                </ModalColabsBody>
                            </ModalColabsContainer>
                        </Overlay>
                    </ContainerBody>
                </ContainerNewDds>
            </Overlay>
            <Overlay state={sideOverlay} changeContent={() => closeSidebar()} >
                <SideMenu>
                    <SideMenuBtn button="GERAR DDS" clickFunc={gerarNovoDDS} />
                </SideMenu>
            </Overlay>
            <Overlay state={modalAnexos} >
                <FileUploader
                    title="Anexar lista DDS"
                    uploadUrl="https://sistemaintegrado.palmont.com.br/Painel/API/DDSList/UploadFile/"
                    extraFormData={
                        { id: idAnexo }
                    }
                    close={closeAnexo}
                    onSuccess={fetchData}
                />
            </Overlay>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="dark"
                style={{
                    zIndex: '99999'
                }}
            />
        </>
    )

}

export default ListaDDS;